import messages from './CPTooltip.message';

const Tooltips = {
    CP7FullSpecialClassValue: messages.CP7FullSpecialClassValue
}

export default Tooltips